module.exports = __webpack_public_path__ + "static/media/play.2228de8b.svg";